import { IOdataField } from '../../IOdataField';

export abstract class OdataFieldThreeValueOperator implements IOdataField {
  private field: IOdataField;
  private field2: IOdataField;
  private field3: IOdataField;
  private operator: string;

  constructor(field1: IOdataField, field2: IOdataField, field3: IOdataField, operator: string) {
    this.field = field1;
    this.field2 = field2;
    this.field3 = field3;
    this.operator = operator;
  }

  toFieldString() {
    return `${this.operator}(${this.field.toFieldString()},${this.field2.toFieldString()},${this.field3.toFieldString()})`;
  };
}
